import React from 'react'
import Video from '../../components/Video'
import CloseBtn from '../CloseBtn2';
import InnerWrap from '../../components/InnerWrap'
import { withUiContext } from "../../UiContext";

const PopupVideo = ({ video, closeHandler }) => {
    
    const onEnded = () => closeHandler()
    
    return (
        <div
            style={{
                position: 'fixed',
                top: 0,
                right: 0,
                bottom: 0,
                left: 0,
                zIndex: 2000
            }}
        >
            <InnerWrap>
                <div className="hud__container-content">
                    <Video video={video} onEnded={onEnded}/>
                    <CloseBtn onClick={closeHandler}/>
                </div>
            </InnerWrap>
        </div>
    )
}

export default withUiContext(PopupVideo)
